import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router } from '@angular/router';
// import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
// import { PopoverModule } from "ngx-smart-popover";


@Component({
  selector: 'app-header-three',
  templateUrl: './header-three.component.html',
  styleUrls: ['./header-three.component.scss'],


})
export class HeaderThreeComponent implements OnInit {


  @Input() class: string = 'header-2';
  @Input() themeLogo: string = 'assets/images/icon/logo.png'; // Default Logo
  @Input() themeIcon: string = 'favicon.ico'; // Default Icon for mobile view
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  public stick: boolean = false;
  loadingAction:boolean = false;
  isHomePage:boolean = false;
  isLogin:boolean = false;
  isCart:boolean=false;
  isLocation:boolean=false;
  isLocation2:boolean=false; 
  // registerForm: FormGroup;
  // submitted = false;


  constructor( private router: Router) { }
  // private formBuilder: FormBuilder
  // convenience getter for easy access to form fields
// get f() { return this.registerForm.controls; }
// onSubmit() {
//     this.submitted = true;
//     // stop here if form is invalid
//     if (this.registerForm.invalid) {
//         return;
//     }

//     }
  ngOnInit(): void {
    this.loadingAction = false;

    if (this.router.url && this.router.url == '/home/vegetable'){
      this.isHomePage = true;
     } else if(this.router.url && this.router.url == '/shop/cart'){
      this.isCart=true;
     } else if(this.router.url && (this.router.url == '/pages/useraccount')){
      this.isLocation=true; 
     } 
      
     if(localStorage.getItem('user')){
      this.isLogin = true;
     }
     if(this.router.url && (this.router.url == '/shop/checkout')){
      this.isLocation2=true; 
     }
     
      
     

     this.loadingAction = true;
  // this.registerForm = this.formBuilder.group({
  //       email: ['', [Validators.required, Validators.email]],
  //       password: ['', [Validators.required, Validators.minLength(6)]]
  //   });
  }





  // @HostListener Decorator
  @HostListener('window:scroll', [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number >= 150 && window.innerWidth > 400) {
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

}
